const FRESH_MS = 120000

function gib(value) {
  return `${(value / (1024 ** 3)).toFixed(1)} GiB`
}

function traffic(value) {
  return Number.isSafeInteger(value) && value >= 0
    ? `${(value / (1024 ** 2)).toFixed(2)} MiB/s` : '미수집'
}

export default function NodePerformance({ agents = [], now = Date.now() }) {
  const linux = agents.filter(agent => /^linux/i.test(agent.os_type || ''))
  return <section className="deploy-panel" aria-labelledby="node-performance-heading">
    <h2 id="node-performance-heading">노드별 성능·트래픽 감지</h2>
    <p>에이전트가 보고한 최신 값만 표시합니다. 배치·부하분산 제어에는 아직 사용하지 않습니다.</p>
    {!linux.length && <p>등록된 리눅스 노드가 없습니다.</p>}
    {!!linux.length && <div className="deploy-node-metrics">{linux.map(agent => {
      const report = agent.runtime_capability
      const resources = report?.resources
      const seen = Date.parse(agent.runtime_capability_seen_at || '')
      const fresh = agent.online === true && agent.runtime_capability_source === 'self-reported-unverified'
        && Number.isFinite(seen) && now - seen >= -30000 && now - seen <= FRESH_MS
      const total = resources?.memory_total_bytes
      const available = resources?.memory_available_bytes
      const memoryValid = Number.isSafeInteger(total) && total > 0
        && Number.isSafeInteger(available) && available >= 0 && available <= total
      const load = resources?.load_one_minute
      return <article key={agent.peer_id} className="deploy-node-metric">
        <h3>{agent.hostname || `노드 ${agent.peer_id}`}</h3>
        <p>{fresh ? '최근 에이전트 보고 · 수치 미검증' : '최신 성능 보고 없음'}</p>
        <dl>
          <div><dt>메모리 사용</dt><dd>{fresh && memoryValid ? `${gib(total - available)} / ${gib(total)}` : '미수집'}</dd></div>
          <div><dt>1분 평균 부하</dt><dd>{fresh && Number.isFinite(load) && load >= 0 ? load.toFixed(2) : '미수집'}</dd></div>
          <div><dt>네트워크 수신</dt><dd>{fresh ? traffic(resources?.network_rx_bytes_per_second) : '미수집'}</dd></div>
          <div><dt>네트워크 송신</dt><dd>{fresh ? traffic(resources?.network_tx_bytes_per_second) : '미수집'}</dd></div>
          <div><dt>트래픽 분산</dt><dd>미연결</dd></div>
        </dl>
      </article>
    })}</div>}
  </section>
}
